import { createIcon } from './create-icon'

export const CheckO = createIcon({
  displayName: 'CheckO',
  paths: [
    'M810.684 512.013c0-26.667-3.883-52.437-10.453-77.056l67.413-67.413c18.133 44.629 28.373 93.312 28.373 144.469 0 212.053-171.947 384-384 384-212.096 0-384-171.947-384-384 0-212.096 171.904-384 384-384 98.347 0 187.776 37.291 255.701 98.091l-60.416 60.416c-52.437-45.44-120.619-73.173-195.285-73.173-164.693 0-298.667 133.973-298.667 298.666s133.973 298.667 298.667 298.667c164.651 0 298.667-133.973 298.667-298.667zM870.98 183.168c16.683-16.683 43.691-16.683 60.373 0 16.64 16.683 16.64 43.648 0 60.331l-371.243 371.242c-26.581 26.581-69.632 26.581-96.213 0l-72.576-72.576c-16.64-16.683-16.64-43.648 0-60.331s43.691-16.683 60.331 0l60.331 60.331 358.997-358.997z'
  ]
})
